import React, { useMemo, useState, useCallback } from "react";

import Modal from "../components/Modal";

interface ModalContext {
  presentModal: (
    modalContent: React.ReactNode,
    fullScreenOnMobile?: boolean
  ) => void;
  dismissModal: () => void;
  setIsEnableBackdropHide: (enable: boolean) => void;
}

export const ModalContext = React.createContext<ModalContext>({
  presentModal: () => {},
  dismissModal: () => {},
  setIsEnableBackdropHide: () => {},
});

export const ModalProvider: React.FC = props => {
  const [isModalPresenting, setIsModalPresenting] = useState(false);
  const [isEnableModalBackdropHide, setIsEnableBackdropHide] = useState(true);
  const [isFullScreenOnMobile, setisFullScreenOnMobile] = useState(false);
  const [
    modalContent,
    setModalContent,
  ] = React.useState<React.ReactNode | null>(null);
  const presentModal = useCallback(
    (modalContent: React.ReactNode, fullScreenOnMobile?: boolean) => {
      setModalContent(modalContent);
      setIsModalPresenting(true);
      if (fullScreenOnMobile !== undefined) {
        setisFullScreenOnMobile(fullScreenOnMobile);
      }
    },
    [setModalContent, setIsModalPresenting]
  );
  const dismissModal = useCallback(() => {
    setIsModalPresenting(false);
    setisFullScreenOnMobile(false);
  }, [setIsModalPresenting]);
  const value = useMemo(() => {
    return {
      presentModal,
      dismissModal,
      setIsEnableBackdropHide,
    };
  }, [presentModal, dismissModal]);

  return (
    <ModalContext.Provider value={value}>
      {props.children}
      {isModalPresenting && (
        <Modal
          content={modalContent}
          dismiss={dismissModal}
          isEnableModalBackdropHide={isEnableModalBackdropHide}
          isFullScreenOnMobile={isFullScreenOnMobile}
        />
      )}
    </ModalContext.Provider>
  );
};
